import { HELP_KEEP_MESSAGE } from '../../../facade/js/measurelengthihm';

import Measureihm from './measurebaseihm';
import FacadeMeasureihm from '../../../facade/js/measurebaseihm';
import FacadeMeasureAreaihm from '../../../facade/js/measureareaihm';

/**
 * @classdesc
 * Main constructor of the class. Creates a MeasureLengthihm
 * control
 *
 * @constructor
 * @extends {M.impl.control.Measureihm}
 * @api stable
 */
export default class MeasureLengthihm extends Measureihm {
  constructor() {
    super('LineString');

    /**
     * Help message
     * @private
     * @type {string}
     */
    this.helpMsg_ = FacadeMeasureihm.HELP_MESSAGE;

    /**
     * Help message
     * @private
     * @type {string}
     */
    this.helpMsgContinue_ = HELP_KEEP_MESSAGE;

    this.name = 'MeasureLengthihm';
  }

  /**
   * This function add tooltip with measureihm distance
   * @public
   * @param {ol.geom.SimpleGeometry} geometry - Object geometry
   * @return {string} output - Indicates the measureihm distance
   * @api stable
   */
  formatGeometry(geometry) {
    const output = [];
    const plugins = this.facadeMap_.getPlugins().filter((plugin) => {
      return plugin.name === 'measurebarihm';
    });
    const conf = plugins[0].getControls().filter((control) => {
      return (control.name === 'measureconfiguracionihm');
    })[0];

    const elemChecked = conf.getImpl().getChecked();
    let checkedrumbo = false;
    let checkedsegmento = false;
    let checkedsismedidas = false;

    elemChecked.forEach((elem) => {
      if (elem === 'rumbo') {
        checkedrumbo = true;
      }
      if (elem === 'segmento') {
        checkedsegmento = true;
      }
      if (elem === 'sismedidas') {
        checkedsismedidas = true;
      }
    });

    if (checkedrumbo) {
      // MEDIDA RUMBO DE LOS TRAMOS
      const unit = '°';
      const point = geometry.getCoordinates();
      const totalpoints = [];
      const pointsLen = geometry.getCoordinates().length;
      for (let i = 0; i < pointsLen; i += 1) {
        totalpoints.push(point[i]);
      }
      const from = totalpoints[pointsLen - 2];
      const to = totalpoints[pointsLen - 1];
      const heading = Math.atan2(to[1] - from[1], to[0] - from[0]);
      const mul = heading * 180;
      const dividir = mul / Math.PI;
      let bearing = 90 - dividir;
      if (bearing < 0) {
        bearing += 360;
      }
      const rumbo = Math.round(bearing * 10) / 10;
      output.push({ name: 'rumbo', valor: `${rumbo} ${unit}` });
    }
    if (checkedsegmento) {
      // medida en NM
      const unit = 'NM';
      const point = geometry.getCoordinates();
      const totalpoints = [];
      const pointsLen = geometry.getCoordinates().length;
      for (let i = 0; i < pointsLen; i += 1) {
        totalpoints.push(point[i]);
      }
      const from = totalpoints[pointsLen - 2];
      const to = totalpoints[pointsLen - 1];
      const codeProj = this.facadeMap_.getProjection().code;
      if (!checkedsismedidas) {
        const line = ol.sphere.getDistance(ol.proj.transform(from, codeProj, 'EPSG:4326'), ol.proj.transform(to, codeProj, 'EPSG:4326'));
        let length = Math.round(line * 100) / 100;
        const inPerDisplayUnit = 72913.4252;
        const inPerMapUnit = 39.3701;
        length *= (inPerMapUnit / inPerDisplayUnit);
        const fmtlength = this.formatNumber(Math.round(length * 100) / 100);
        output.push({ name: 'segmento', valor: `${fmtlength} ${unit}` });
      } else {
        let length = null;
        length = ol.sphere.getDistance(ol.proj.transform(from, codeProj, 'EPSG:4326'), ol.proj.transform(to, codeProj, 'EPSG:4326'));
        if (length > 1000) {
          output.push({ name: 'segmento', valor: `${this.formatNumber(Math.round(((length / 1000) * 100)) / 100)} km` });
        } else {
          output.push({ name: 'segmento', valor: `${this.formatNumber(Math.round(length * 100) / 100)} m` });
        }
      }
    }
    if (checkedsismedidas) {
      let length = null;
      const codeProj = this.facadeMap_.getProjection().code;
      if (codeProj === 'EPSG:3857') {
        length = Math.round(ol.sphere.getLength(geometry) * 100) / 100;
      }
      if (length > 1000) {
        output.push({ name: 'KM', valor: `${this.formatNumber(Math.round(((length / 1000) * 100)) / 100)} km` });
      } else {
        output.push({ name: 'KM', valor: `${this.formatNumber(Math.round(length * 100) / 100)} m` });
      }
    }
    if (!checkedsismedidas) {
      // medida en NM
      const unit = 'NM';
      let length = Math.round(ol.sphere.getLength(geometry) * 100) / 100;
      const inPerDisplayUnit = 72913.4252;
      const inPerMapUnit = 39.3701;
      length *= (inPerMapUnit / inPerDisplayUnit);
      // output = length + unit;
      output.push({ name: 'NM', valor: `${this.formatNumber(Math.round(length * 100) / 100)} ${unit}` });
    }
    return output;
  }

  /**
   * This function returns coordinates to tooltip
   * @public
   * @param {ol.geom.SimpleGeometry} geometry - Object geometry
   * @return {array} coordinates to tooltip
   * @api stable
   */
  getTooltipCoordinate(geometry) {
    return geometry.getLastCoordinate();
  }

  activate() {
    const measureArea = this.facadeMap_.getControls().filter((control) => {
      return (control instanceof FacadeMeasureAreaihm);
    })[0];
    if (measureArea) {
      measureArea.deactivate();
    }
    super.activate();
    // document.querySelector('.m-control.m-measurelengthihm-container').classList.add('activated');
  }

  /* eslint-disable newline-per-chained-call */
  formatNumber(number) {
    return `${number}`.replace(/\d(?=(\d{3})+\.)/g, '$&*').split('.').join(',').split('*').join('.');
  }
}
